export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProcessInfo.vue?vue&type=template&id=0927b93d&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Macro/ProcessInfo.vue?vue&type=template&id=0927b93d&scoped=true
// module id = 1742
// module chunks = 31